module.exports = __webpack_public_path__ + "static/petroshop-cover-3c89207b3964c2eb08eef10c5c2bda33.jpg";